import { render, staticRenderFns } from "./VoucherTracking.vue?vue&type=template&id=241f4756"
import script from "./VoucherTracking.vue?vue&type=script&lang=ts"
export * from "./VoucherTracking.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports